import { BaseError, createErrorBuilder, } from '@wix/public-editor-platform-errors';
export var ExternalPanelsAPIErrorCode;
(function (ExternalPanelsAPIErrorCode) {
    ExternalPanelsAPIErrorCode["EditorPointerAPINotProvided"] = "EditorPointerAPINotProvided";
    ExternalPanelsAPIErrorCode["CantGetNamespace"] = "CantGetNamespace";
})(ExternalPanelsAPIErrorCode || (ExternalPanelsAPIErrorCode = {}));
class ExternalPanelsAPIError extends BaseError {
    constructor(message, code) {
        super(message, code, 'EP ExternalPanelsAPIError Error');
    }
    withDefineNamespaceData(data) {
        this.state = {
            ...this.state,
            ...data,
        };
        return this;
    }
    withHostType(hostType) {
        this.state = {
            ...this.state,
            hostType,
        };
        return this;
    }
}
export const createEditorPlatformPrivateAPIError = createErrorBuilder(ExternalPanelsAPIError);
//# sourceMappingURL=errors.js.map